import React from "react";

function Card({ title, body, tag }) {
  return (
    <div
      style={{
        borderRadius: 16,
        padding: "1.25rem 1.25rem",
        backgroundColor: "#ffffff",
        boxShadow: "0 10px 30px rgba(15,23,42,0.06)",
        border: "1px solid rgba(148,163,184,0.25)",
        display: "flex",
        flexDirection: "column",
        gap: "0.5rem",
      }}
    >
      {tag && (
        <span
          style={{
            alignSelf: "flex-start",
            fontSize: 11,
            padding: "0.1rem 0.55rem",
            borderRadius: 999,
            backgroundColor: "rgba(15,23,42,0.06)",
            color: "#475569",
            fontWeight: 500,
          }}
        >
          {tag}
        </span>
      )}
      <h3
        style={{ margin: 0, fontSize: 16, fontWeight: 600, color: "#0f172a" }}
      >
        {title}
      </h3>
      <p style={{ margin: 0, fontSize: 14, color: "#475569" }}>{body}</p>
    </div>
  );
}

export default Card;
